import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mt-icon-view',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './icon-view.ui-component.html',
  styleUrl: './icon-view.ui-component.scss',
})
export class IconViewUiComponent {}
